<template>
  <div>
    <a-modal
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      v-model="showModal"
      title="Social Sharing"
      :footer="null"
    >
      <ShareNetwork
        network="facebook"
        :url="url"
        :title="title"
        :description="description"
        >Facebook</ShareNetwork
      >
      <ShareNetwork
        network="twitter"
        :url="url"
        :title="title"
        :description="description"
        >Twitter</ShareNetwork
      >
      <ShareNetwork
        network="linkedin"
        :url="url"
        :title="title"
        :description="description"
        >LinkedIn</ShareNetwork
      >
      <ShareNetwork
        network="pinterest"
        :url="url"
        :title="title"
        :description="description"
        >Pinterest</ShareNetwork
      >
      <ShareNetwork
        network="email"
        :url="url"
        :title="title"
        :description="description"
        >Email</ShareNetwork
      >
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "SocialSharing",
  data() {
    return {
      showModal: false,
      url: "",
      title: "",
      description: ""
    };
  },
  methods: {
    show(url, title, description) {
      this.url = url;
      this.title = title;
      this.description = description;
      this.showModal = true;
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Modals/SocialSharing.vue